// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"419120b9","457":"c1e00960","572":"847251ca","596":"15ea9077","710":"ee49f93d","760":"967ede88","845":"b16266a0","953":"416be325"}[chunkId] + ".chunk.js";
};